import React, { useState, useEffect, useRef } from "react";
import config from "../../config.json";
import hakImage from '../../images/hak.png';
import { Person } from "../../domain/Person";

interface Props {
    changeStepClick: (stepName: string) => void;
    documents: Array<{ name: string, path: string }>;
    greeter: Person;
}

const Documents: React.FC<Props> = ({ changeStepClick, documents, greeter }) => {
    const [active, setActive] = useState(documents[0] || { name: "No documents", path: "" });
    const [accepted, setAccepted] = useState<Array<string>>([]);
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        if (!documents || documents.length === 0) {
            changeStepClick("guestCard");
        }
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    const acceptDocu = (path: string) => {
        const newAccepted = [...accepted, path];

        if (newAccepted.length >= documents.length) {
            timeoutRef.current = setTimeout(() => {
                changeStepClick("guestCard");
            }, 1500);
        }

        setAccepted(newAccepted);
        setActive(
            newAccepted.length < documents.length
                ? documents[newAccepted.length]
                : active
        );
    };

    return (
        <>
            <h1>Læs dokumenter:</h1>
            <div className='reception-documents'>
                <div className='documents-list'>
                    {documents.map(x => {
                        const isActive = x.path === active.path;
                        const isAccept = accepted.find(y => y === x.path);
                        return (
                            <div key={x.path}>
                                <div
                                    className={`non button${isAccept ? ' green' : isActive ? ' pink' : ''}`}
                                    onClick={() => setActive(x)}
                                >
                                    {x.name}
                                    {isAccept && <><div className='space' /><img className={'hak-image'} src={hakImage} alt='approved' /></>}
                                </div>
                                {isActive && !isAccept &&
                                    <div className='button sm pink' onClick={() => acceptDocu(x.path)}>Læst og forstået</div>
                                }
                            </div>
                        );
                    })}
                </div>
                <div className='document-preview-container'>
                    <embed key={`${config.server}${active.path}`} src={`${config.server}${active.path}`} />
                </div>
                <div className='docu-message'>
                    <img src={`${config.server}${greeter.imagePath}`} alt='greeter' />
                    <div className='msg'>
                        "Du må meget gerne læse disse dokumenter og herefter trykke læst og forstået"
                    </div>
                </div>
            </div>
        </>
    );
};

export default Documents;